import { render } from "./KitchenNavigation.vue?vue&type=template&id=695d30fa"
import script from "./KitchenNavigation.vue?vue&type=script&lang=js"
export * from "./KitchenNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__